import { Grid, TextField, useMediaQuery } from '@mui/material';

import AliasInput from 'components/AliasInput/AliasInput';
import { useTranslation } from 'react-i18next';
import { FieldTemplateFormProps } from '.';
import ReactCodeMirror from '@uiw/react-codemirror';
import FieldTemplateChipList from './components/FieldTemplateChipList';
import { php } from '@codemirror/lang-php';

export function CalculatedFieldTemplate({
  formik,
  disabled,
}: FieldTemplateFormProps) {
  const { t } = useTranslation();
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');

  return (
    <form>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            disabled={disabled}
            sx={{ mt: 1 }}
            fullWidth
            label={`${t('forms.fieldAttributes.label')} *`}
            type="text"
            name="label"
            value={formik.values.label}
            onChange={formik.handleChange}
            error={formik.touched.label && Boolean(formik.errors.label)}
            InputLabelProps={{
              shrink: true,
            }}
            helperText={formik.touched.label && formik.errors.label}
          />
        </Grid>

        <Grid item xs={6}>
          <AliasInput
            disabled={disabled}
            type="text"
            name="alias"
            value={formik.values.alias}
            onChange={formik.handleChange}
            fullWidth
            error={formik.touched.alias && Boolean(formik.errors.alias)}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            disabled={disabled}
            fullWidth
            label={t('forms.fieldAttributes.unit')}
            type="unit"
            name="unit"
            value={formik.values.unit}
            onChange={formik.handleChange}
            error={formik.touched.unit && Boolean(formik.errors.unit)}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>

        <Grid
          item
          xs={12}
          sx={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'row',
            mt: 2,
          }}
        >
          <FieldTemplateChipList parentAlias={formik.values.alias} />
        </Grid>

        <Grid item xs={12}>
          <ReactCodeMirror
            editable={!disabled}
            value={formik.values.code}
            height="300px"
            theme={prefersDarkMode ? 'dark' : 'light'}
            style={{ borderRadius: 4 }}
            onChange={value => {
              if (!disabled) formik.setFieldValue('code', value);
            }}
            extensions={[php()]}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            disabled={disabled}
            sx={{ mt: 1 }}
            fullWidth
            label={t('forms.fieldAttributes.description')}
            type="text"
            name="description"
            value={formik.values.description}
            onChange={formik.handleChange}
            multiline
            rows={3}
            error={
              formik.touched.description && Boolean(formik.errors.description)
            }
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
      </Grid>
    </form>
  );
}
